<template>
  <div class="container">
    <!-- 添加栏目 -->
    <div class="vue">
      <div class="header flex">
        <div class="text">添加栏目</div>
      </div>
      <div class="content ">
        <a-form-model
          ref="ruleForm"
          :model="form"
          :rules="rules"
          :label-col="labelCol"
          :wrapper-col="wrapperCol"
        >
          <a-form-model-item ref="name" label="栏目名" prop="name">
            <a-input
              v-model="form.name"
              @blur="
                () => {
                  $refs.name.onFieldBlur()
                }
              "
            /> </a-form-model-item
          ><a-form-model-item ref="url" label="路径地址" prop="url">
            <a-input
              v-model="form.url"
              @blur="
                () => {
                  $refs.url.onFieldBlur()
                }
              "
            />
          </a-form-model-item>
          <a-form-model-item
            ref="sequence"
            label="排序（正序）"
            prop="sequence"
          >
            <a-input v-model="form.sequence" />
          </a-form-model-item>
          <a-form-model-item label="上级菜单">
            <a-select v-model="form.superiors" placeholder="">
              <a-select-option value="0">
                无上级菜单
              </a-select-option>
              <a-select-option
                :value="item.id"
                v-for="item in AdminList"
                :key="item.id"
              >
                {{ item.name }}
              </a-select-option>
            </a-select>
          </a-form-model-item>
          <a-form-model-item :wrapper-col="{ span: 14, offset: 4 }">
            <a-button
              :loading="SubmitLoad"
              type="primary"
              @click="onSubmit('ruleForm')"
            >
              确认
            </a-button>
            <a-button style="margin-left: 10px;" @click="resetForm">
              取消
            </a-button>
          </a-form-model-item>
        </a-form-model>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: '',
  props: [''],
  data() {
    return {
      AdminList: [], // 导航栏列表
      labelCol: { span: 4 },
      wrapperCol: { span: 14 },
      other: '',
      form: {
        name: '',
        url: '',
        sequence: '', // 排序
        superiors: '0' // 上级id
      },
      rules: {
        name: [
          {
            required: true,
            message: '请输入栏目名!',
            trigger: 'blur'
          }
        ],
        url: [
          {
            required: true,
            message: '请输入路径地址!',
            trigger: 'blur'
          }
        ],
        sequence: [
          {
            required: true,
            message: '请输入排序，数值越小越靠前!',
            trigger: 'blur'
          }
        ]
      },
      SubmitLoad: false
    }
  },

  components: {},

  computed: {},

  beforeMount() {},

  mounted() {
    this.NavigationFindAll()
  },

  methods: {
    // 提交
    onSubmit(e) {
      console.log(e)
      this.$refs.ruleForm.validate(res => {
        if (res) {
          let superiors
          if (this.form.superiors === '0') {
            superiors = ''
          } else {
            superiors = this.form.superiors
          }
          this.SubmitLoad = true
          this.$postAxios('/navigation/addNavigation', {
            name: this.form.name,
            parentId: superiors,
            url: this.form.url,
            sequence: this.form.sequence
          }).then(res => {
            if (res.status === '0') {
              this.$message.success(res.msg)
              this.$refs[e].resetFields()
              this.SubmitLoad = false
            }
          })
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    resetForm() {
      this.$router.go(-1)
    },
    /* 接口 */
    // 获取列表
    NavigationFindAll() {
      this.$postAxios('/navigation/findLevelOne').then(res => {
        if (res.status === '0') {
          this.AdminList = res.data.map(function(item) {
            return { name: item.name, id: item.id.toString() }
          })
          console.log(this.AdminList)
        }
      })
    }
  },

  watch: {}
}
</script>
<style lang="scss" scoped>
$colorMajor: #005ca1;
.vue {
  padding: 10px;
  background-color: #fff;
  border-left: 2px solid $colorMajor;
  .header {
    justify-content: space-between;
    .text {
      text-align: left;
      // font-size: 0.875em;
      color: $colorMajor;
      padding: 10px 5px;
    }
    .el-button {
      margin: 10px;
    }
  }
  .content {
    flex-direction: column;
    align-items: center;
    justify-content: center;
  }
}
</style>
